module.exports = {
	"base": {
		"welcome": "Velkommen til Mulligans, %{name}!",
		"user": "Brukerinfo",
		"devices": "Enheter",
		"refunds": "Refusjoner",
		"resources": "Ressurser",
		"transactions": "Bestillinger og returer",
		"email": "E-post",
		"password": "Passord",
		"save": "Lagre",
		"sign-out": "Logg av",
		"cancel": "Avbryt",
		"close": "Lukk",
		"learn-more": "Finn ut mer",
		"required": "Påkrevd",
		"support": "Støtte",
		"bookshelf": "Bookshelf",
		"launch": "Start",
		"download": "Last ned",
		"details": "Detaljer",
		"cannot-be-blank": "%{field} kan ikke være tomt.",
		"saving": "Lagrer...",
		"done": "Fullført",
		"failed": "Mislyktes",
		"copy": "Kopier"
	},
	"signin": {
		"login-failure": "E-postaddresse eller passord er feil",
		"welcome-large": "Velkommen til <span class='inner'>%{brand} Account Center</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Logg på",
		"forgot-password": "Glemt passordet",
		"new-to-vst": "Ny hos %{brand}?",
		"create-account": "Opprett en konto",
		"signing-in": "Logger på...",
		"signin-failed": "Pålogging mislyktes"
	},
	"transactions": {
		"price": "Pris",
		"excluded": "(Ekskl. mva)",
		"quantity": "Mengde",
		"confirmation#": "Bekreftelse #",
		"payment": "Betaling",
		"purchased": "Kjøpt",
		"purchase-details": "Kjøpsdetaljer",
		"subtotal": "Delsum",
		"total": "Total",
		"tax": "Avgift",
		"loading": "Heisann, vi laster dine transaksjoner...",
		"no-purchases": "Du har ingen kjøp.",
		"seller-vat": "Selger MVA",
		"total-vat": "Total %{vat} betalt",
		"portion": "%{subTax} Skatt %{rate}%",
		"vat-disclosure": "Prisen inkluderer %{vat}",
		"purchases": "Kjøp",
		"refunded-items": "Refunderte elementer",
		"book-title": "Boktittel",
		"refund-details": "Detaljer om tilbakebetaling",
		"print-receipt": "Skriv ut kvittering",
		"request-refund": "Forespør om refusjon",
		"expired": "Utløpt",
		"expires-in": "Utløper %{date}",
		"details-refund": "Informasjon og refusjon",
		"modal": {
			"cant-refund-title": "Refusjon ikke tilgjengelig",
			"cant-refund": "Boken kan ikke bli refundert på grunn av en eller flere av følgende grunner.",
			"cant-refund-1": "For mye av boken har blitt vist.",
			"cant-refund-2": "Det har gått mer enn 14 dager siden kjøpsdatoen.",
			"cant-refund-3": "Din online ressurskode har blitt vist.",
			"cant-refund-4": "Boken har blitt refundert tidligere.",
			"cant-refund-5": "Alle koder er allerede innløst og/eller refundert.",
			"cant-refund-6": "Det har gått mer enn 30 dager siden kjøpsdatoen.",
			"cant-refund-support": "Hvis du fortsatt er usikker på %{brand}s angrerett-policy, kontakt <a href='%{support_url}' target='_blank'>kundestøtte</a>."
		},
		"license": {
			"perpetual": "Elektronisk tilgang utløper ikke",
			"days": "%{days} dagers tilgang"
		}
	},
	"devices": {
		"description": "%{brand} tillater deg å ha <span>%{desktop}</span> datamaskiner og <span>%{mobile}</span> mobil-/nettbrettenheter aktivert på et gitt tidspunkt.",
		"loading": "Hei, vi henter enhetene dine :)",
		"no-active": "Du har ingen aktive enheter.",
		"deactivate": "Deaktiver"
	},
	"user": {
		"personal-information": "Personlig informasjon",
		"security-information": "Sikkerhetsinformasjon",
		"notifications": "Varsler",
		"first-name": "Fornavn",
		"last-name": "Etternavn",
		"change-password-title": "Endre passord",
		"current-password": "Nåværende passord",
		"new-password": "Nytt passord",
		"security-password": "Passord",
		"confirm-new-password": "Bekreft nytt passord",
		"security-question": "Sikkerhetsspørsmål",
		"security-info-change": "Endre",
		"question": "Spørsmål",
		"answer": "Svar",
		"notifications-text": "Send meg sporadiske oppdateringer om min kontoaktivitet, produktoppdateringer og spesialtilbud.",
		"loading": "Spot er ute og henter inn brukerinformasjonen, et øyeblikk 🐶",
		"change-password-text": "Passord må inneholde minst 8 tegn, en stor bokstav, en liten bokstav, og et spesialtegn.",
		"email-locked": "E-post låst",
		"email-locked-description": "Du har ikke tilgang til å endre din e-post.",
		"email-locked-more": "Vennligst ta kontakt med administratoren.",
		"security-question6": "Hva er din favorittsport?",
		"security-question7": "Hva er din favoritt-iskremsmak?",
		"security-question8": "Hva er navnet på ditt favorittkjæledyr?",
		"security-question9": "Da du var ung, hva ville du bli når du ble stor?",
		"security-question10": "Hva var etternavnet til din favorittlærer?",
		"new-password-failure": "Passordet oppfyller ikke kravene",
		"confirm-password-failure": "Passordene må samsvare",
		"new-password-tooltip": "Må inneholde minst 8 tegn, en stor bokstav, en liten bokstav, og et spesialtegn.",
		"enter-valid-email": "Vennligst skriv inn en gyldig e-postadresse.",
		"password-cannot-be-same": "Passordet kan ikke være det samme som det forrige passordet",
		"incorrect-password": "Feil passord",
		"complete-account": "Ser ut som du må <a href='%{href}'>fullføre kontoen</a>.",
		"completing-allows": "Når du fullfører kontoen din, kan du lese bøker frakoblet på mobilappene, og dele notater og uthevinger med venner.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Hjelpeutstyr",
		"access-codes": "Adgangskoder",
		"print-on-demand": "Skriv ut etter behov",
		"check-pod": "Sjekk utgivers utskriftsalternativer for bøkene dine.",
		"check-now": "Sjekk nå",
		"loading": "Vent litt, vi oppdaterer dine ressurser!",
		"in": "i",
		"access-code-intro": "En adgangskode er et passord du bruker for å få tilgang til kursinnhold på nettet. Når du viser en kode for et element, kan du ikke returnere den. For mer instruksjoner om hvordan du bruker dine adgangskoder, besøk <a href='%{support_url}' target='_blank'>kundestøtte</a>.",
		"expires": "Utløper",
		"expiration-message": "Inneholder instruksjoner for bruk av adgangskoden.",
		"copy-fail": "Kunne ikke kopiere. Velg koden og kopier den manuelt.",
		"launch-site": "Start hjemmesiden",
		"launch-book": "Start bok",
		"reveal-code": "Vis kode",
		"no-resources": "Du har ingen ressurser.",
		"no-access-codes": "Du har ingen adgangskoder.",
		"no-ancillaries": "Ingen hjelpemidler for denne tittelen",
		"name": "Navn",
		"type": "Type",
		"size": "Størrelse",
		"download-all": "Last ned alle",
		"back": "Tilbake til ressurser"
	},
	"refunds": {
		"states": {
			"refunded": "Refundert",
			"unavailable": "Refusjon utilgjengelig"
		},
		"reasons": {
			"dropped": "Jeg droppet kurset",
			"wrong": "Det var feil bok for kurset mitt",
			"print": "Jeg bestemte meg for å kjøpe en trykket versjon i stedet",
			"missing": "Boken inneholder ikke alt jeg trenger for kurset (f.eks. en CD, nettilgang, videoer)",
			"other": "Andre"
		},
		"bulk": {
			"policy": "Ved å klikke på &quot;Full refusjon&quot;-knappen nedenfor, godtar jeg %{brand}s <a href='%{policy_url}' target='_blank'>angrerett</a>.",
			"complete": "Full refusjon",
			"view-details": "Se detaljer om refusjon",
			"success": "Refusjonen din ble forespurt. Behandlingen kan ta 48 timer.",
			"failure": "Oops - noe gikk galt Dessverre gikk ikke refusjonen gjennom.",
			"retry": "Prøv igjen",
			"support": "Kontakt kundestøtte",
			"available-codes": "Tilgjengelige koder",
			"codes-selected": "Koder valgt",
			"download": "Last ned koder",
			"partially-refunded": "Delvis refundert",
			"pick-one": "Du må velge minst én kode for å gjøre en refusjon"
		},
		"refund": "Refusjon",
		"all": "Refundere alle?",
		"missing-reason": "Du må velge en grunn for å fortsette",
		"missing-elaboration": "Vennligst forklar nærmere",
		"policy": "Ved å klikke på \"Fullfør refusjonsforespørsel\"-knappen nedenfor, forstår jeg at hvis jeg kjøper denne e-læreboken fra %{brand} på nytt, vil jeg ikke være kvalifisert til å be om ytterligere refusjoner for samme e-lærebok. Se full angrerett-policy.",
		"refunded": "Refundert",
		"sorry": "Vi beklager at du ikke var fornøyd med kjøpet.",
		"error": "Noe gikk galt",
		"error-explain": "Kunne ikke behandle refusjonen. Vennligst prøv på nytt.",
		"why": "Fortell oss hvorfor.",
		"no-refunds": "Du har ingen refunderte elementer.",
		"select-codes": "Velg kode(r) å refundere:",
		"number": "Hvor mange?",
		"back": "Tilbake til refusjoner"
	},
	"purchases": {
		"back": "Tilbake til kjøp"
	},
	"global-bar": {
		"account": "Kontoinnstillinger"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/no.json
 ** module id = 1017
 ** module chunks = 0
 **/